//@flow

import React from 'react';

import withTrekEditPermission from '../../HOCs/withTrekEditPermission';

type Props = {
  children: Object,
  onEditPress: () => void,
  extraClass: boolean,
  isOwner: boolean,
  isFrozen: boolean,
  parentExtraClass: string,
};

function EditButton({
  children,
  onEditPress,
  extraClass,
  isFrozen,
  isOwner,
  parentExtraClass,
}: Props) {
  if (isFrozen) return null;

  if (!isOwner) return null;

  if (children) {
    return (
      <p className={parentExtraClass ? parentExtraClass : ''}>
        <a onClick={onEditPress}>{children}</a>
      </p>
    );
  }

  return (
    <span onClick={onEditPress} className={extraClass ? 'edit-button' : ''}>
      <i className="icon icon-hg-edit-pencil" aria-hidden="true" /> Edit
    </span>
  );
}

export default withTrekEditPermission(EditButton);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/NewEditButton.jsx